<template>
  <div id="RelatedContentList">
    <div class="slick-container">
      <slick ref="slickRef" class="slick-class" :options="slickOptions">
        <button
          v-for="(article, index) in articleArray"
          :key="index"
          @click="handleClick(article.id)"
          class="article-button"
        >
          <img class="article-image" :src="article.image_url" :alt="article.title">
          <h4 class="article-title">{{ article.title }}</h4>
          <p class="article-duration">{{ article.text }}</p>
        </button>
      </slick>
    </div>
  </div>
</template>

<script>
import slick from "vue-slick";

export default {
  name: "RelatedContentList",
  props: ["articleArray"],
  components: {
    slick,
  },
  data() {
    return {
      slickOptions: {
        infinite: false,
        nextArrow: `<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>`,
        prevArrow: `<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>`,
        slidesToScroll: 3,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 578,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ]
      }
    };
  },
  computed: {
    passedArticleId() {
      return this.$route.params.articleId;
    },
  },
  methods: {
    handleClick(articleId) {
      this.$router.push(`/articles/${articleId}`)
    }
  }
};
</script>

<style lang="less">
#RelatedContentList {
  .article-button {
    position: relative;
    background-color: unset;
    border: 0;
    padding: 0;
  }

  .article-image {
    width: 100%;
    height: 110px;
    object-fit: cover;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .article-title {
    text-align: left;
    font-family: "DMSans Bold";
    font-weight: 700;
    color: #0f152e;
    font-size: 1.4rem;
    line-height: 2.2rem;
    margin: 0;
  }

  .slick-container {
    max-width: 660px;
  }

  .slick-slider {
    position: relative;
  }

  .slick-track {
    margin: 0 -6px;
  }

  .slick-next,
  .slick-prev {
    position: absolute;
    z-index: 10;
    top: 60px;
    background-color: transparent;
    border: none;
    padding: 0 6px;

    .fa {
      font-size: 3rem;
      color: #1e1e22;
    }
  }

  .slick-next {
    right: -20px;
  }

  .slick-prev {
    left: -28px;
  }

  .slick-slide {
    transform: none !important;
    margin: 0 8px;
  }

  .slick-disabled {
    display: none !important;
  }
}
</style>
